import { FC } from "react";
import { SegmentType } from "src/Modules/Flights/constants";
import { buildJourneySummary, timelineToItem } from "../../utils";
import { Timeline } from "src/components";
import { AirplaneIcon } from "src/assets/Icons";
import { formatTimeFromUnit } from "src/utility";

const JourneyPaths: FC<{ segments: SegmentType[] }> = ({ segments }) => {
  return (
    <div className="@container flex w-full flex-1 items-center">
      <div className="flex flex-1 flex-col items-center justify-center gap-6 p-1 md:gap-3">
        {segments.map((segment, index) => {
          const { stopLabel, timeline, totalDuration } = buildJourneySummary(segment);
          const items = timeline.map(timelineToItem) ?? [];
          const OverflowIndicator = (
            <div className="text-icon-secondary flex -translate-y-px items-center gap-2 bg-background-default px-2">
              <div className="flex items-center">
                <AirplaneIcon
                  fill="var(--color-icon-secondary)"
                  className="w-5 md:w-full aspect-square"
                  transform={index === 1 ? "scale(-1,1)" : undefined}
                  mirrorInRtl
                />
              </div>
              <div className="flex items-center">{formatTimeFromUnit(totalDuration, "m")}</div>
            </div>
          );
          return (
            <div className="flex w-full flex-1 flex-col gap-1 rounded-sm p-2 text-[clamp(.8rem,2cqw,3rem)]" key={segment?.origin}>
              <div>
                <Timeline
                  maxVisibleItems={1}
                  items={items}
                  overflowIndicator={OverflowIndicator}
                  className="w-full"
                  classNames={{
                    connector: {
                      rail: "flex-4 border-border-default! border-dashed! border-t! translate-y-1/2!",
                      head: "bg-transparent!",
                    },
                    item: "flex-1!",
                  }}
                />
              </div>
              <div className="text-font-subtle text-sm font-semibold">{stopLabel}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default JourneyPaths;
